import api from '@/utils/api';

/**
 * Get Quoting Customer Contacts
 * @param {string} customerId - The customer ID.
 * @returns {Promise}
 */
const getQuotingCustomerContactsApi = (customerId) =>
  api.get(`/conf/contacts/${customerId}`);

export default getQuotingCustomerContactsApi;
